import React, { useRef, useState, useMemo } from 'react';
import classnames from 'classnames';
import { positions } from './coords';
import * as styles from './Marker.scss';


const MarkerIcon = ({ variant }) => {
  switch (variant) {
    case 'filled':
      return (
        <svg
          width="18"
          height="22"
          viewBox="0 0 18 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.5382 22C6.99758 20.6835 5.56957 19.2402 4.2691 17.6852C2.31751 15.35 1.07784e-06 11.8723 1.07784e-06 8.55833C-0.00172871 5.09715 2.07874 1.97605 5.27059 0.651444C8.46244 -0.673163 12.1365 0.059819 14.5784 2.50835C16.1841 4.10988 17.0836 6.28838 17.0764 8.55833C17.0764 11.8723 14.7589 15.35 12.8073 17.6852C11.5068 19.2402 10.0788 20.6835 8.5382 22Z"
            fill="currentColor"
          />
          <path
            d="M8.65923 12.3318C6.63829 12.3318 5 10.6905 5 8.66591C5 6.64128 6.63829 5 8.65923 5C10.6802 5 12.3185 6.64128 12.3185 8.66591C12.3185 9.63817 11.9329 10.5706 11.2467 11.2581C10.5605 11.9456 9.62972 12.3318 8.65923 12.3318Z"
            fill="white"
          />
        </svg>
      );
    default:
      return (
        <svg
          width="18"
          height="22"
          viewBox="0 0 18 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.500001 8.55833L0.500001 8.55808C0.498372 5.29869 2.45754 2.3602 5.46224 1.11326C8.4668 -0.133627 11.9254 0.556222 14.2243 2.86142L14.2253 2.86237C15.7365 4.3696 16.5832 6.42004 16.5764 8.55675V8.55833C16.5764 10.104 16.034 11.7198 15.2306 13.2573C14.4293 14.7906 13.3856 16.2135 12.4238 17.3645C11.233 18.7882 9.93393 20.117 8.5382 21.3389C7.14247 20.117 5.84336 18.7882 4.65264 17.3645C3.69076 16.2135 2.64709 14.7906 1.84585 13.2573C1.04244 11.7198 0.500001 10.104 0.500001 8.55833ZM8.5388 1.94848L8.5376 1.94848C4.89451 1.95285 1.94385 4.91021 1.93949 8.55773V8.55833C1.93949 10.14 2.65353 12.7169 5.75746 16.4377L5.7578 16.4381C6.52282 17.3532 7.33454 18.2281 8.18972 19.0592L8.53798 19.3977L8.88645 19.0595C9.74163 18.2294 10.5537 17.3558 11.3194 16.4423L11.3204 16.4411C14.4229 12.7155 15.1369 10.1387 15.1369 8.55833V8.55773C15.1326 4.91021 12.1819 1.95285 8.5388 1.94848ZM8.5382 11.7242C6.79427 11.7242 5.37897 10.3077 5.37897 8.55833C5.37897 6.80898 6.79427 5.39242 8.5382 5.39242C10.2821 5.39242 11.6974 6.80898 11.6974 8.55833C11.6974 9.39827 11.3644 10.2036 10.7718 10.7973C10.1792 11.3909 9.37579 11.7242 8.5382 11.7242Z"
            fill="currentColor"
            stroke="currentColor"
          />
        </svg>
      );
  }
};

const OsloIcon = ({variant}) => {
  switch (variant) {
    case 'filled':
      return (
        <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="19" cy="19" r="19" fill="white"/>
          <path d="M22.33 20.6724L22.4868 20.2102L22.4909 16.4463H21.2215V21.679H25.0243V20.5111H22.8606L22.33 20.6724ZM29.5434 19.0623C29.5434 19.9298 30.1725 20.5838 31.0067 20.5838C31.8326 20.5838 32.4555 19.9358 32.4555 19.0768V19.0623C32.4555 18.1951 31.8263 17.5411 30.9922 17.5411C30.1662 17.5411 29.5434 18.189 29.5434 19.0481V19.0623ZM33.7756 19.0481V19.0623C33.7756 20.5782 32.553 21.7657 30.9922 21.7657C29.4137 21.7657 28.2233 20.6099 28.2233 19.0768V19.0623C28.2233 17.5466 29.4458 16.3591 31.0067 16.3591C32.5852 16.3591 33.7756 17.515 33.7756 19.0481ZM5.42522 19.0623C5.42522 19.9298 6.05435 20.5838 6.88852 20.5838C7.71448 20.5838 8.33732 19.9358 8.33732 19.0768V19.0623C8.33732 18.1951 7.70844 17.5411 6.87427 17.5411C6.04807 17.5411 5.42522 18.189 5.42522 19.0481V19.0623ZM9.65765 19.0481V19.0623C9.65765 20.5782 8.43489 21.7657 6.87427 21.7657C5.29553 21.7657 4.10515 20.6099 4.10515 19.0768V19.0623C4.10515 17.5466 5.32766 16.3591 6.88852 16.3591C8.46701 16.3591 9.65765 17.515 9.65765 19.0481ZM36.3867 18.9998C36.3867 9.41294 28.587 1.61326 18.9999 1.61326C9.413 1.61326 1.61351 9.41294 1.61351 18.9998C1.61351 28.5868 9.413 36.3865 18.9999 36.3865C28.587 36.3865 36.3867 28.5868 36.3867 18.9998ZM38 18.9998C38 29.4765 29.4767 38 18.9999 38C8.52328 38 0 29.4765 0 18.9998C0 8.52323 8.52328 0 18.9999 0C29.4767 0 38 8.52323 38 18.9998ZM15.5272 18.4866C14.6098 18.2518 14.4876 18.1545 14.4876 17.8927V17.8792C14.4876 17.6555 14.7138 17.5114 15.0645 17.5114C15.4512 17.5114 15.8695 17.6708 16.3428 17.999L16.4056 18.0424L16.4273 18.0106L16.9432 16.9825C16.41 16.5791 15.7842 16.3724 15.08 16.3724C13.9874 16.3724 13.2245 17.0334 13.2245 17.9799V17.9944C13.2245 19.0896 13.9797 19.3693 14.9669 19.6214C15.7977 19.8339 15.9318 19.9641 15.9318 20.1933V20.2085C15.9318 20.4606 15.6866 20.6111 15.2758 20.6111C14.7689 20.6111 14.3018 20.4205 13.8063 20.0114L13.7481 19.9634L13.7468 19.9648L13.5819 19.8214L13.0344 20.912L13.0462 20.9226C13.4909 21.3177 14.0335 21.5807 14.616 21.6928L14.6141 21.6884C14.823 21.7288 15.0367 21.7508 15.2536 21.7508C16.4327 21.7508 17.1946 21.1023 17.1946 20.0989V20.0848C17.1946 19.1198 16.5283 18.7479 15.5272 18.4866Z" fill="currentColor"/>
        </svg>
      );
    default: 
      return (
        <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.33 20.6724L22.4868 20.2102L22.4909 16.4463H21.2215V21.679H25.0243V20.5111H22.8606L22.33 20.6724ZM29.5434 19.0623C29.5434 19.9298 30.1725 20.5838 31.0067 20.5838C31.8326 20.5838 32.4555 19.9358 32.4555 19.0768V19.0623C32.4555 18.1951 31.8263 17.5411 30.9922 17.5411C30.1662 17.5411 29.5434 18.189 29.5434 19.0481V19.0623ZM33.7756 19.0481V19.0623C33.7756 20.5782 32.553 21.7657 30.9922 21.7657C29.4137 21.7657 28.2233 20.6099 28.2233 19.0768V19.0623C28.2233 17.5466 29.4458 16.3591 31.0067 16.3591C32.5852 16.3591 33.7756 17.515 33.7756 19.0481ZM5.42522 19.0623C5.42522 19.9298 6.05435 20.5838 6.88852 20.5838C7.71448 20.5838 8.33732 19.9358 8.33732 19.0768V19.0623C8.33732 18.1951 7.70844 17.5411 6.87427 17.5411C6.04807 17.5411 5.42522 18.189 5.42522 19.0481V19.0623ZM9.65765 19.0481V19.0623C9.65765 20.5782 8.43489 21.7657 6.87427 21.7657C5.29553 21.7657 4.10515 20.6099 4.10515 19.0768V19.0623C4.10515 17.5466 5.32766 16.3591 6.88852 16.3591C8.46701 16.3591 9.65765 17.515 9.65765 19.0481ZM36.3867 18.9998C36.3867 9.41294 28.587 1.61326 18.9999 1.61326C9.413 1.61326 1.61351 9.41294 1.61351 18.9998C1.61351 28.5868 9.413 36.3865 18.9999 36.3865C28.587 36.3865 36.3867 28.5868 36.3867 18.9998ZM38 18.9998C38 29.4765 29.4767 38 18.9999 38C8.52328 38 0 29.4765 0 18.9998C0 8.52323 8.52328 0 18.9999 0C29.4767 0 38 8.52323 38 18.9998ZM15.5272 18.4866C14.6098 18.2518 14.4876 18.1545 14.4876 17.8927V17.8792C14.4876 17.6555 14.7138 17.5114 15.0645 17.5114C15.4512 17.5114 15.8695 17.6708 16.3428 17.999L16.4056 18.0424L16.4273 18.0106L16.9432 16.9825C16.41 16.5791 15.7842 16.3724 15.08 16.3724C13.9874 16.3724 13.2245 17.0334 13.2245 17.9799V17.9944C13.2245 19.0896 13.9797 19.3693 14.9669 19.6214C15.7977 19.8339 15.9318 19.9641 15.9318 20.1933V20.2085C15.9318 20.4606 15.6866 20.6111 15.2758 20.6111C14.7689 20.6111 14.3018 20.4205 13.8063 20.0114L13.7481 19.9634L13.7468 19.9648L13.5819 19.8214L13.0344 20.912L13.0462 20.9226C13.4909 21.3177 14.0335 21.5807 14.616 21.6928L14.6141 21.6884C14.823 21.7288 15.0367 21.7508 15.2536 21.7508C16.4327 21.7508 17.1946 21.1023 17.1946 20.0989V20.0848C17.1946 19.1198 16.5283 18.7479 15.5272 18.4866Z" fill="currentColor"/>
        </svg>
      );
  }
}

const Marker = ({
  page,
  isHighlighted,
  isSelected,
  isMapHover,
  isHover,
  onHover,
  onSelect,
  posFactor
}) => {
  const position = positions[page.name];
  if(!position) {
    return null;
  }
  const isOslo = page.name === 'Oslo' ;

  const left = positions[page.name].x * posFactor;
  const top = positions[page.name].y * posFactor;

  return (
    <div
      className={classnames(styles.marker, {
        [styles.highlighted]: isHighlighted,
        [styles.selected]: isSelected,
        [styles.mapHover]: isMapHover,
        [styles.hover]: isHover,
        [styles.oslo]: isOslo
      })}
      style={{
        top,
        left,
      }}
      onMouseEnter={() => onHover(page.name)}
      onMouseLeave={() => onHover(null)}
      onClick={() => onSelect(page)}
    >
      {isOslo ? (
        <OsloIcon variant={isHover && !isHighlighted && !isSelected ? 'filled' : false} />
      ) : (
        <>
          <MarkerIcon variant={isHighlighted && !isSelected && !isHover ? 'filled' : false} />
          {isHover || (isSelected && !isMapHover) ? (
            <span className={styles.label}>{page.name}</span>
          ) : null}
        </>
      )}
    </div>
  );
};


export default Marker;
